module.exports = __webpack_public_path__ + "media/images/common/ticket-20d99f5d4cb957deb4c19d9e054e2ee0.png";